document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pp-carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.pp-track');
    var prevBtn = wrap.querySelector('.pp-nav--prev');
    var nextBtn = wrap.querySelector('.pp-nav--next');

    // --- "Voir plus" / "Voir moins" sur les avis longs (au-delà de 5 lignes) ---
    var section = wrap.closest('.pp-section');
    var i18nScriptTag = section ? section.nextElementSibling : null;
    if (!i18nScriptTag || i18nScriptTag.tagName !== 'SCRIPT') {
      i18nScriptTag = document.querySelector('script[data-i18n-read-more]');
    }
    var readMoreText = (i18nScriptTag && i18nScriptTag.getAttribute('data-i18n-read-more')) || 'Voir plus';
    var readLessText = (i18nScriptTag && i18nScriptTag.getAttribute('data-i18n-read-less')) || 'Voir moins';

    wrap.querySelectorAll('[data-pp-review-quote]').forEach(function (quoteEl) {
      var toggleBtn = quoteEl.nextElementSibling;
      if (!toggleBtn || !toggleBtn.hasAttribute('data-pp-quote-toggle')) return;
      // On attend une frame pour que la mise en page (et le clamp CSS) soit
      // stable avant de mesurer si le texte déborde vraiment.
      requestAnimationFrame(function () {
        if (quoteEl.scrollHeight > quoteEl.clientHeight + 2) {
          toggleBtn.hidden = false;
          toggleBtn.textContent = readMoreText;
          toggleBtn.addEventListener('click', function () {
            var expanded = quoteEl.classList.toggle('pp-quote-expanded');
            toggleBtn.textContent = expanded ? readLessText : readMoreText;
          });
        }
      });
    });

    if (!track || !prevBtn || !nextBtn) return;

    function cardStep() {
      var card = track.querySelector('.pp-card');
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(track).gap || '20');
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  // --- Modale "Laisser un avis" ---
  var MAX_SELECTED_PRODUCTS = 10;
  var RESULTS_PAGE_SIZE = 20; // combien de résultats affichés à la fois (pagination côté client)
  var CATALOG_PAGE_SIZE = 250; // max autorisé par l'API Storefront par page
  var CATALOG_MAX_PRODUCTS = 2000; // filet de sécurité pour les très gros catalogues

  // Cache partagé (par langue) du catalogue produit complet, pour ne le
  // télécharger qu'une seule fois même si plusieurs boutons "Laisser un avis"
  // existent sur la page. La recherche Shopify (paramètre `query`) ne
  // cherche JAMAIS dans les titres traduits, seulement dans la langue par
  // défaut de la boutique (limitation connue de l'API Storefront) — on
  // contourne ça en récupérant tout le catalogue dans la bonne langue
  // (via @inContext) et en filtrant nous-mêmes côté JS.
  var catalogCache = {}; // languageCode -> [{title, handle}]
  var catalogPromises = {}; // languageCode -> Promise

  function fetchProductCatalogPage(shopDomain, storefrontToken, languageCode, cursor) {
    var query =
      'query CatalogPage($first: Int!, $after: String, $lang: LanguageCode) @inContext(language: $lang) {' +
      ' products(first: $first, after: $after) {' +
      '   edges { cursor node { title handle } }' +
      '   pageInfo { hasNextPage }' +
      ' } }';

    return fetch('https://' + shopDomain + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken,
      },
      body: JSON.stringify({
        query: query,
        variables: { first: CATALOG_PAGE_SIZE, after: cursor || null, lang: languageCode },
      }),
    }).then(function (res) {
      return res.json();
    });
  }

  function getProductCatalog(shopDomain, storefrontToken, languageCode) {
    if (catalogCache[languageCode]) {
      return Promise.resolve(catalogCache[languageCode]);
    }
    if (catalogPromises[languageCode]) {
      return catalogPromises[languageCode];
    }

    var allProducts = [];

    function loadPage(cursor) {
      return fetchProductCatalogPage(shopDomain, storefrontToken, languageCode, cursor).then(function (data) {
        var result = data && data.data && data.data.products;
        if (!result) return allProducts;
        result.edges.forEach(function (edge) {
          allProducts.push({ title: edge.node.title, handle: edge.node.handle });
        });
        var lastCursor = result.edges.length ? result.edges[result.edges.length - 1].cursor : null;
        if (result.pageInfo.hasNextPage && allProducts.length < CATALOG_MAX_PRODUCTS && lastCursor) {
          return loadPage(lastCursor);
        }
        return allProducts;
      });
    }

    catalogPromises[languageCode] = loadPage(null).then(function (products) {
      catalogCache[languageCode] = products;
      delete catalogPromises[languageCode];
      return products;
    });

    return catalogPromises[languageCode];
  }

  document.querySelectorAll('[data-pp-open-modal]').forEach(function (openBtn) {
    var section = openBtn.closest('.pp-section');
    var modal = section && section.querySelector('[data-pp-modal]');
    if (!modal) return;

    // Le <script> qui porte les données (proxy, token, domaine) est le frère
    // suivant la balise </section> pour cette même instance de section.
    var scriptTag = section.nextElementSibling;
    if (!scriptTag || scriptTag.tagName !== 'SCRIPT') {
      scriptTag = document.querySelector('script[data-proxy-path]');
    }
    var proxyPath = (scriptTag && scriptTag.getAttribute('data-proxy-path')) || '/apps/avis/submit';
    var storefrontToken = scriptTag ? scriptTag.getAttribute('data-storefront-token') : '';
    var shopDomain = scriptTag ? scriptTag.getAttribute('data-shop-domain') : '';
    var rawLocale = (scriptTag && scriptTag.getAttribute('data-locale')) || 'en';
    // Convertit "fr", "en", "pt-BR" -> "FR", "EN", "PT_BR" (format attendu
    // par l'enum LanguageCode de l'API Storefront).
    var languageCode = rawLocale.replace('-', '_').toUpperCase();

    // Tous les textes affichés par ce script viennent des réglages de
    // section (traduisibles depuis l'éditeur de thème) plutôt que d'être
    // codés en dur ici, pour rester cohérents avec le Liquid.
    function i18n(key, fallback) {
      var value = scriptTag && scriptTag.getAttribute('data-i18n-' + key);
      return value || fallback;
    }
    var I18N = {
      errorGeneric: i18n('error-generic', 'Une erreur est survenue, réessaie dans un instant.'),
      errorMissingFields: i18n('error-missing-fields', 'Merci de remplir tous les champs.'),
      errorNoProduct: i18n('error-no-product', 'Merci de sélectionner au moins un produit dans la liste.'),
      errorMaxProducts: i18n('error-max-products', 'Tu peux lier jusqu\u2019à [max] produits maximum.'),
      errorPhotoTooLarge: i18n('error-photo-too-large', 'La photo dépasse 5 Mo, merci d\u2019en choisir une autre.'),
      loadingProducts: i18n('loading-products', 'Chargement des produits...'),
      errorSearchUnconfigured: i18n('error-search-unconfigured', 'Recherche produit non configurée.'),
      errorSearchUnavailable: i18n('error-search-unavailable', 'Recherche indisponible pour le moment.'),
      noProductsFound: i18n('no-products-found', 'Aucun produit trouvé.'),
      loadMore: i18n('load-more', 'Charger plus de résultats'),
      submitLoading: i18n('submit-loading', 'Envoi...'),
      submitDefault: i18n('submit-default', 'Envoyer mon avis'),
      removeProductAria: i18n('remove-product-aria', 'Retirer [title]'),
      readMore: i18n('read-more', 'Voir plus'),
      readLess: i18n('read-less', 'Voir moins'),
    };

    var form = modal.querySelector('[data-pp-form]');
    var quoteField = modal.querySelector('[data-pp-quote]');
    var charCount = modal.querySelector('[data-pp-char-count]');
    var errorEl = modal.querySelector('[data-pp-form-error]');
    var successEl = modal.querySelector('[data-pp-form-success]');
    var submitBtn = modal.querySelector('[data-pp-submit]');
    var maxLength = quoteField ? parseInt(quoteField.getAttribute('maxlength'), 10) || 600 : 600;

    var savedScrollY = 0;

    function openModal() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      // Technique robuste pour iOS : "overflow: hidden" seul sur le body ne
      // suffit pas et bloque aussi le scroll À L'INTÉRIEUR de la modale sur
      // mobile. On fige le body en position fixed à la place.
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      modal.hidden = false;
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, savedScrollY);
      resetIOSZoom();
    }

    // Filet de sécurité : si iOS a zoomé sur un champ (police < 16px ailleurs
    // dans le thème, ou navigateur plus ancien), on force un retour à
    // l'échelle normale en modifiant brièvement le viewport.
    function resetIOSZoom() {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) return;
      var original = viewport.getAttribute('content');
      if (!original) return;
      viewport.setAttribute('content', original + ', maximum-scale=1.0');
      setTimeout(function () {
        viewport.setAttribute('content', original);
      }, 350);
    }

    openBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-pp-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (quoteField && charCount) {
      quoteField.addEventListener('input', function () {
        // Ceinture de sécurité côté client : on tronque au cas où
        // (le vrai plafond doit être appliqué côté serveur).
        if (quoteField.value.length > maxLength) {
          quoteField.value = quoteField.value.slice(0, maxLength);
        }
        charCount.textContent = quoteField.value.length;
      });
    }

    // --- Recherche multi-produits (toujours active : le choix boutique/produit
    // n'est plus proposé côté client, tout avis soumis ici est un avis produit) ---
    var productFieldWrap = modal.querySelector('[data-pp-product-field]');
    var productChipsWrap = modal.querySelector('[data-pp-product-chips]');
    var productSearchInput = modal.querySelector('[data-pp-product-search]');
    var productHandlesInput = modal.querySelector('[data-pp-product-handles]');
    var productSuggestionsList = modal.querySelector('[data-pp-product-suggestions]');
    var searchDebounceTimer;
    var selectedProducts = []; // [{ handle, title }]

    function syncHiddenField() {
      if (!productHandlesInput) return;
      productHandlesInput.value = JSON.stringify(
        selectedProducts.map(function (p) {
          return p.handle;
        })
      );
    }

    function renderChips() {
      if (!productChipsWrap) return;
      productChipsWrap.innerHTML = '';
      selectedProducts.forEach(function (product, index) {
        var chip = document.createElement('span');
        chip.className = 'pp-product-chip';

        var label = document.createElement('span');
        label.textContent = product.title;

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.textContent = '×';
        removeBtn.setAttribute('aria-label', I18N.removeProductAria.replace('[title]', product.title));
        removeBtn.addEventListener('click', function () {
          selectedProducts.splice(index, 1);
          renderChips();
          syncHiddenField();
        });

        chip.appendChild(label);
        chip.appendChild(removeBtn);
        productChipsWrap.appendChild(chip);
      });
    }

    function addProduct(product) {
      var alreadySelected = selectedProducts.some(function (p) {
        return p.handle === product.handle;
      });
      if (alreadySelected) return;
      if (selectedProducts.length >= MAX_SELECTED_PRODUCTS) {
        errorEl.textContent = I18N.errorMaxProducts.replace('[max]', MAX_SELECTED_PRODUCTS);
        errorEl.hidden = false;
        return;
      }
      selectedProducts.push(product);
      renderChips();
      syncHiddenField();
      productSearchInput.value = '';
      productSuggestionsList.hidden = true;
      productSuggestionsList.innerHTML = '';
    }

    function filterCatalog(catalog, term) {
      var needle = term.toLowerCase();
      return catalog.filter(function (product) {
        return product.title.toLowerCase().indexOf(needle) !== -1;
      });
    }

    function renderSuggestions(matches, offset, append) {
      if (!append) {
        productSuggestionsList.innerHTML = '';
      } else {
        var oldLoadMore = productSuggestionsList.querySelector('.pp-load-more');
        if (oldLoadMore) oldLoadMore.remove();
      }

      if (!matches.length && !append) {
        var emptyLi = document.createElement('li');
        emptyLi.className = 'pp-no-results';
        emptyLi.textContent = I18N.noProductsFound;
        productSuggestionsList.appendChild(emptyLi);
        productSuggestionsList.hidden = false;
        return;
      }

      var page = matches.slice(offset, offset + RESULTS_PAGE_SIZE);

      page.forEach(function (product) {
        var li = document.createElement('li');
        li.textContent = product.title;
        li.tabIndex = 0;
        li.addEventListener('click', function () {
          addProduct({ handle: product.handle, title: product.title });
        });
        productSuggestionsList.appendChild(li);
      });

      var newOffset = offset + page.length;
      if (newOffset < matches.length) {
        var loadMoreLi = document.createElement('li');
        loadMoreLi.className = 'pp-load-more';
        loadMoreLi.textContent = I18N.loadMore;
        loadMoreLi.tabIndex = 0;
        loadMoreLi.addEventListener('click', function () {
          renderSuggestions(matches, newOffset, true);
        });
        productSuggestionsList.appendChild(loadMoreLi);
      }

      productSuggestionsList.hidden = false;
    }

    if (productSearchInput) {
      productSearchInput.addEventListener('input', function () {
        var query = productSearchInput.value.trim();
        clearTimeout(searchDebounceTimer);

        if (query.length < 2) {
          productSuggestionsList.hidden = true;
          productSuggestionsList.innerHTML = '';
          return;
        }

        if (!storefrontToken || !shopDomain) {
          productSuggestionsList.innerHTML = '';
          var errLi = document.createElement('li');
          errLi.className = 'pp-no-results';
          errLi.textContent = I18N.errorSearchUnconfigured;
          productSuggestionsList.appendChild(errLi);
          productSuggestionsList.hidden = false;
          return;
        }

        // Affiche un état de chargement pendant le premier téléchargement du
        // catalogue (les recherches suivantes sont instantanées, tout est en cache).
        if (!catalogCache[languageCode]) {
          productSuggestionsList.innerHTML = '';
          var loadingLi = document.createElement('li');
          loadingLi.className = 'pp-no-results';
          loadingLi.textContent = I18N.loadingProducts;
          productSuggestionsList.appendChild(loadingLi);
          productSuggestionsList.hidden = false;
        }

        searchDebounceTimer = setTimeout(function () {
          getProductCatalog(shopDomain, storefrontToken, languageCode)
            .then(function (catalog) {
              // Le champ peut avoir changé pendant le chargement : on
              // relit sa valeur actuelle plutôt que d'utiliser `query`.
              var currentQuery = productSearchInput.value.trim();
              if (currentQuery.length < 2) {
                productSuggestionsList.hidden = true;
                return;
              }
              var matches = filterCatalog(catalog, currentQuery);
              renderSuggestions(matches, 0, false);
            })
            .catch(function () {
              productSuggestionsList.innerHTML = '';
              var errLi2 = document.createElement('li');
              errLi2.className = 'pp-no-results';
              errLi2.textContent = I18N.errorSearchUnavailable;
              productSuggestionsList.appendChild(errLi2);
              productSuggestionsList.hidden = false;
            });
        }, 200);
      });

      document.addEventListener('click', function (e) {
        if (!productFieldWrap.contains(e.target)) {
          productSuggestionsList.hidden = true;
        }
      });
    }

    // --- Aperçu de la photo ---
    var photoInput = modal.querySelector('[data-pp-photo-input]');
    var photoPreviewWrap = modal.querySelector('[data-pp-photo-preview]');
    var photoPreviewImg = modal.querySelector('[data-pp-photo-preview-img]');
    var photoRemoveBtn = modal.querySelector('[data-pp-photo-remove]');
    var MAX_PHOTO_BYTES = 5 * 1024 * 1024;

    if (photoInput) {
      photoInput.addEventListener('change', function () {
        var file = photoInput.files[0];
        if (!file) {
          photoPreviewWrap.hidden = true;
          return;
        }
        if (file.size > MAX_PHOTO_BYTES) {
          errorEl.textContent = I18N.errorPhotoTooLarge;
          errorEl.hidden = false;
          photoInput.value = '';
          photoPreviewWrap.hidden = true;
          return;
        }
        var reader = new FileReader();
        reader.onload = function (ev) {
          photoPreviewImg.src = ev.target.result;
          photoPreviewWrap.hidden = false;
        };
        reader.readAsDataURL(file);
      });

      if (photoRemoveBtn) {
        photoRemoveBtn.addEventListener('click', function () {
          photoInput.value = '';
          photoPreviewWrap.hidden = true;
        });
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        errorEl.hidden = true;
        successEl.hidden = true;

        var fullNameField = form.querySelector('[name="full_name"]');
        var ratingChecked = form.querySelector('[name="rating"]:checked');
        var quoteValue = quoteField.value.trim().slice(0, maxLength);
        quoteField.value = quoteValue;

        if (!fullNameField.value.trim() || !ratingChecked || !quoteValue) {
          errorEl.textContent = I18N.errorMissingFields;
          errorEl.hidden = false;
          return;
        }

        if (productHandlesInput && selectedProducts.length === 0) {
          errorEl.textContent = I18N.errorNoProduct;
          errorEl.hidden = false;
          return;
        }

        // FormData transporte directement le fichier photo (multipart),
        // pas besoin de le convertir en JSON/base64.
        var formData = new FormData(form);

        submitBtn.disabled = true;
        submitBtn.textContent = I18N.submitLoading;

        fetch(proxyPath, {
          method: 'POST',
          body: formData, // pas de header Content-Type : le navigateur gère le multipart automatiquement
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || !result.data.success) {
              throw new Error((result.data && result.data.error) || 'request_failed');
            }
            form.reset();
            if (charCount) charCount.textContent = '0';
            if (photoPreviewWrap) photoPreviewWrap.hidden = true;
            selectedProducts = [];
            renderChips();
            syncHiddenField();
            if (productFieldWrap) productFieldWrap.hidden = true;
            // Le message de succès s'affiche en tout dernier, une fois que
            // TOUT le nettoyage a réussi sans erreur — évite d'afficher
            // succès + erreur en même temps si une étape plante en cours de route.
            successEl.hidden = false;
            setTimeout(closeModal, 2500);
          })
          .catch(function () {
            successEl.hidden = true;
            errorEl.textContent = I18N.errorGeneric;
            errorEl.hidden = false;
          })
          .finally(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = I18N.submitDefault;
          });
      });
    }
  });
});